import DeviceManager from '../utils/device-manager';

const TestimonialsSwiper = {
    $swipers: [],
    swipers: {},

    init() {
        this.$swipers = document.querySelectorAll('.testimonial-swiper');

        this.$swipers.forEach(($swiper, index) => {
            this.initSwiper($swiper, index);
        });
    },

    initSwiper($swiper, name) {
        const $slides = $swiper.querySelectorAll('.swiper-slide');

        let args = {
            updateOnWindowResize: true,
            slidesPerView: 1,
            loop: false,
            allowTouchMove: true,
            threshold: 10,
            spaceBetween: 20,
            autoHeight: true,
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            pagination: $slides.length > 1 ? {
                el: '.swiper-pagination',
                clickable: true,
            } : false,
            breakpoints: {},
            observer: true,
            observeParents: true,
        };

        this.swipers[name] = new Swiper($swiper, args);

        this.swipers[name].on ('activeIndexChange', (swiper) => {
            const $currentSlide = swiper.slides[swiper.activeIndex];
            const height = $currentSlide.querySelector('.citation').offsetHeight + $currentSlide.querySelector('.author').offsetHeight + 50;

            $swiper.querySelector('.swiper-wrapper').style.height = height + 'px';
        });
        
        setTimeout(function () {
            /* window.dispatchEvent(new Event('resize'));
            $swiper.swiper.init(); */
            // if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                var evt = document.createEvent('UIEvents');
                evt.initUIEvent('resize', true, false, window, 0);
                window.dispatchEvent(evt);
            // } else {
                window.dispatchEvent(new Event('resize'));
            // }
            // $slides.init();
            }, 2000);
    }
}

export default TestimonialsSwiper;